import { useEffect, useState } from 'react';

import { useBrand } from '@cof/plastic-components';
import config from '@cof/ukweb-config/lib/clientConfig';
import { useAdobeExperiments } from '../../experiments/AdobeExperiment/AdobeExperimentProvider';
import { getFullExperimentString } from '../../experiments/getExperimentString';
import { setNewRelicAttribute } from '../newRelic';

// @ts-expect-error TS2339: Property 'initializeZuko' does not exist on type 'Window & typeof globalThis'.
window.initializeZuko = (slug: any, isEnabled: any) => {
    // @ts-expect-error TS2339: Property 'Zuko' does not exist on type 'Window & typeof globalThis'.
    if (isEnabled && window.Zuko && window.zukoAttributes && !window.zukoInstance) {
        // @ts-expect-error TS2339: Property 'zukoAttributes' does not exist on type 'Window & typeof globalThis'.
        const zukoAttr = window.zukoAttributes;
        // @ts-expect-error TS2339: Property 'Zuko' does not exist on type 'Window & typeof globalThis'.
        const zukoVisitorId = window?.Zuko?.getVisitorId?.();

        if (zukoVisitorId) setNewRelicAttribute('zukoVisitorId', zukoVisitorId);

        // @ts-expect-error TS2339: Property 'zukoInstance' does not exist on type 'Window & typeof globalThis'.
        window.zukoInstance = window.Zuko.trackForm({ slug, target: zukoAttr.formEl })
            .setAttribute('formDefinitionId', zukoAttr.formDefinitionId)
            .setAttribute('onlineEntryMethodCode', zukoAttr.onlineEntryMethodCode)
            .setAttribute('journeyType', zukoAttr.journeyType)
            .setAttribute('consumerName', zukoAttr.consumerName)
            .setAttribute('doubleClickId', zukoAttr.doubleClickId)
            .setAttribute('experimentChar', zukoAttr.experimentChar)
            .setAttribute('webpage', zukoAttr.webpage)
            .setAttribute('AdobeExperiment', zukoAttr.AdobeExperiment)
            // @ts-expect-error TS2339: Property 'Zuko' does not exist on type 'Window & typeof globalThis'.
            .trackEvent(window.Zuko.FORM_VIEW_EVENT);
    }
};

// eslint-disable-next-line import/prefer-default-export
export const useZuko = ({
    formDefinitionId,
    onlineEntryMethodCode,
    consumerName,
    journeyType,
    doubleClickId,
    experimentChar,
    webpageChar
}: any) => {
    const [formEl, setFormEl] = useState(null);
    const brand = useBrand();
    const zukoConfig = config.get('zuko');
    // @ts-expect-error TS7053: Element implicitly has an 'any' type because expression of type '"capitalOneSlug" | "lumaSlug" | "ve
    const slug = zukoConfig[`${brand}Slug`] || zukoConfig.slug;
    const adobeState = useAdobeExperiments();

    useEffect(() => {
        const AdobeExperiment = getFullExperimentString(adobeState);

        // Validate the required attributes exist. doubleClickId & formDefinitionId is optional
        if (formEl && onlineEntryMethodCode && journeyType && consumerName) {
            // @ts-expect-error TS2339: Property 'zukoAttributes' does not exist on type 'Window & typeof globalThis'.
            window.zukoAttributes = {
                formEl,
                formDefinitionId,
                onlineEntryMethodCode,
                journeyType,
                consumerName,
                doubleClickId,
                experimentChar,
                webpage: webpageChar,
                AdobeExperiment
            };
        }
        // Also called in GTM Zuko tag
        // @ts-expect-error TS2339: Property 'initializeZuko' does not exist on type 'Window & typeof globalThis'.
        window.initializeZuko(slug, zukoConfig.isEnabled);
    }, [
        formEl,
        formDefinitionId,
        onlineEntryMethodCode,
        consumerName,
        journeyType,
        doubleClickId,
        experimentChar,
        webpageChar,
        adobeState,
        slug,
        zukoConfig.isEnabled
    ]);

    const trackCompletionEvent = () => {
        // @ts-expect-error TS2339: Property 'zukoInstance' does not exist on type 'Window & typeof globalThis'.
        if (typeof window?.zukoInstance?.trackEvent === 'function') {
            try {
                // @ts-expect-error TS2339: Property 'zukoInstance' does not exist on type 'Window & typeof globalThis'.
                window.zukoInstance.trackEvent(window.Zuko.COMPLETION_EVENT);
            } catch (e) {
                // eslint-disable-next-line no-console
                console.log(e);
            }
        }
    };

    const trackValidationError = (field: any) => {
        // @ts-expect-error TS2339: Property 'zukoInstance' does not exist on type 'Window & typeof globalThis'.
        if (typeof window?.zukoInstance?.trackEvent === 'function') {
            try {
                // @ts-expect-error TS2339: Property 'zukoInstance' does not exist on type 'Window & typeof globalThis'.
                window.zukoInstance.trackEvent({ type: `submit-validation-error:${field}` });
            } catch (e) {
                // eslint-disable-next-line no-console
                console.log(e);
            }
        }
    };

    return { setFormEl, trackCompletionEvent, trackValidationError };
};
